import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Environment } from '../models/environment.model';
import {
  AlgorithmFeed,
  AlgorithmSettings,
  AlgorithmUpdatePayload,
} from '../models/algorithm.model';

@Injectable({ providedIn: 'root' })
export class AlgorithmService {
  constructor(
    private httpClient: HttpClient,
    @Inject('environment') private environment: Environment,
  ) {}

  getSettings(feed: AlgorithmFeed): Observable<AlgorithmSettings> {
    return this.httpClient.get<AlgorithmSettings>(
      `${this.environment.api.url}/admin/algorithm/${feed}`,
    );
  }

  updateSettings(
    feed: AlgorithmFeed,
    payload: AlgorithmUpdatePayload,
  ): Observable<{ feed: AlgorithmFeed; percents: { [key: string]: number } }> {
    return this.httpClient.put<{ feed: AlgorithmFeed; percents: { [key: string]: number } }>(
      `${this.environment.api.url}/admin/algorithm/${feed}`,
      payload,
    );
  }

  /** Reset a feed to code defaults by removing the stored override. */
  resetSettings(feed: AlgorithmFeed): Observable<AlgorithmSettings> {
    return this.httpClient.delete<AlgorithmSettings>(
      `${this.environment.api.url}/admin/algorithm/${feed}`,
    );
  }
}
